<mat-form-field
    [appearance]="input.appearance"
    [floatLabel]="input.floatLabel"
    [ngClass]="wrapperClasses">
    <mat-label>{{ input.label }}</mat-label>
    <input
        #dateInput
        matInput
        [matDatepicker]="picker"
        [required]="input.required"
        placeholder="mm/dd/yyyy"
        [aria-describedby]="dateInput.id + editPromptSuffix"
        (blur)="blurEvent($event)"
        (focus)="focusEvent($event)"
        [formControl]="input.control" />
    <mat-datepicker-toggle
        *ngIf="!input.control.disabled"
        matSuffix
        [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-hint [ngClass]="hint?.class">{{ hint?.message }}</mat-hint>
    <mat-error>{{ errorMessage }}</mat-error>
</mat-form-field>
